
import React from 'react';
import KameService from '../services/kame';
import ServiceAwardsService from '../services/service-awards';
import SolutionsService from '../services/solution';
import ExperienceService from '../services/experience';
import { getKey } from '../utils/hierarchy';
import { Building, Template, WorkBag, Notes } from '@nackle/origami-icons';
function HierarchyStore( { auth } ) {
    const key = getKey( { auth } );
    const solutionService = new SolutionsService( auth.state );
    const experienceService = new ExperienceService( auth.state );
    const kameService = new KameService( auth.state );
    const serviceAwardsService = new ServiceAwardsService( auth.state );

    let getItemsPromise = null;

    function getItems() {
        if ( !getItemsPromise ) {
            getItemsPromise = new Promise( ( resolve, reject ) => {
                const onError = ( ex ) => {
                    console.error( ex );
                    reject( ex.errors );
                };

                experienceService.listExperiences().then( experiences => {
                    solutionService.listSolutions().then( solutions => {
                        kameService.listPrograms().then ( kamePrograms => {
                            serviceAwardsService.listPrograms().then( serviceAwardsPrograms => {
                                const items = [ {
                                    id: auth.state.claims.company_id,
                                    type: 'COMPANY',
                                    name: 'Company',
                                    icon: <Building />
                                } ];

                                solutions.forEach( solution => {
                                    items.push( {
                                        id: solution.id,
                                        type: 'SOLUTION',
                                        name: `Solution: ${ solution.name }`,
                                        icon: <Template />
                                    } );

                                    experiences.forEach( experience => {
                                        if ( solution.experiences.includes( experience.id ) ) {
                                            items.push( {
                                                id: experience.id,
                                                type: 'EXPERIENCE',
                                                name: `Experience: ${ experience.name }`,
                                                icon: <WorkBag />
                                            } );
                                        }
                                    } );
                                } );

                                kamePrograms.forEach( program => {
                                    items.push( {
                                        id: program.id,
                                        type: 'PROGRAM',
                                        name: `Program: ${ program.name }`,
                                        icon: <Notes />
                                    } );
                                } );

                                serviceAwardsPrograms.forEach( program => {
                                    items.push( {
                                        id: program.programId,
                                        type: 'PROGRAM',
                                        name: `Program: ${ program.name }`,
                                        icon: <Notes />
                                    } );
                                } );

                                resolve( {
                                    items: items.sort( ( a, b ) => (
                                        a.name.localeCompare( b.name, undefined, { sensitivity: 'base' } )
                                    ) )
                                } );
                            } ).catch ( onError );
                        } ).catch ( onError );
                    } ).catch ( onError );
                } ).catch ( onError );
            } );
        }

        return getItemsPromise;
    }

    return {
        key,
        getItems
    };
}

// need to keep a mapping to seperate companyId
const storeMap = {};

export default function( props ) {
    const storeKey = getKey( props );
    if ( !storeMap[ storeKey ] ) {
        storeMap[ storeKey ] = new HierarchyStore( props );
    }
    return storeMap[ storeKey ];
}
